import { render, staticRenderFns } from "./PhoneMock.vue?vue&type=template&id=259bd852&scoped=true&"
import script from "./PhoneMock.vue?vue&type=script&lang=js&"
export * from "./PhoneMock.vue?vue&type=script&lang=js&"
import style0 from "./PhoneMock.vue?vue&type=style&index=0&id=259bd852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bd852",
  null
  
)

export default component.exports